<template>
  <span
    :class="[
      $attrs.class,
      props?.symbols
        ? 'material-symbols-outlined'
        : props?.outlined
        ? 'material-icons-outlined'
        : 'material-icons',
    ]"
    >{{ props.icon }}</span
  >{{ printSpace() }}
</template>

<script setup lang="ts">
const props = defineProps<{
  icon: string
  space?: Boolean
  outlined?: Boolean
  symbols?: Boolean
}>()
const printSpace = () => (props?.space ? ' ' : '')
</script>
